import { render, staticRenderFns } from "./AppConfirmationDialog.vue?vue&type=template&id=00837535&scoped=true"
import script from "./AppConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./AppConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00837535",
  null
  
)

export default component.exports